"use client";
import { cn } from "@/lib/tailwind";
import TextTruncate from "../textTruncate/TextTruncate";
import { HeaderVariantWithSubheading } from "./type";
import AllViewExpandableContent from "@/components/AllViewExpandableContent";
import { useParams } from "next/navigation";

//md:h-[5.875rem]

const WithSubHeading = ({
  subheading,
  bgClassName,
  withBackground = true,
  translations,
}: HeaderVariantWithSubheading) => {
  const params = useParams();
  const locale = params?.locale as string;

  return withBackground ? (
    <div
      className={cn(
        "flex w-full items-center justify-center px-4 py-2 text-center",
        bgClassName,
      )}
    >
      <AllViewExpandableContent text={subheading} translations={translations} locale={locale} />
    </div>
  ) : (
    <AllViewExpandableContent text={subheading} translations={translations} locale={locale} />
  );
};

export default WithSubHeading;
